import Portfolio6_2 from './Portfolio6_2'
export default Portfolio6_2
